import * as React from "react";
import { SVGProps } from "react";

const SvgSevenSpades = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 251 351"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M241 0H10.4S.7.3.7 13.1v323.8c0 12.8 9.7 13.1 9.7 13.1H241s9.7-.3 9.7-13.1V13.1C250.7.3 241 0 241 0Z"
      fill="#fff"
    />
    <mask
      id="seven-spades_svg__b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={188}
      width={251}
      height={162}
    >
      <path
        d="M148.1 188.8c-49.1 0-98.2 0-147.3.1v147.9c0 12.8 9.7 13.1 9.7 13.1H241s9.7-.3 9.7-13.1v-148H148.1Z"
        fill="url(#seven-spades_svg__a)"
      />
    </mask>
    <g mask="url(#seven-spades_svg__b)">
      <path
        d="M148.1 188.8c-49.1 0-98.2 0-147.3.1v147.9c0 12.8 9.7 13.1 9.7 13.1H241s9.7-.3 9.7-13.1v-148H148.1Z"
        fill="url(#seven-spades_svg__c)"
      />
    </g>
    <mask
      id="seven-spades_svg__e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={251}
      height={175}
    >
      <path
        d="M.8 174.5h249.9V13.1C250.7.3 241 0 241 0H10.5S.8.3.8 13.1V174.5Z"
        fill="url(#seven-spades_svg__d)"
      />
    </mask>
    <g mask="url(#seven-spades_svg__e)">
      <path
        d="M.8 174.5h249.9V13.1C250.7.3 241 0 241 0H10.5S.8.3.8 13.1V174.5Z"
        fill="url(#seven-spades_svg__f)"
      />
    </g>
    <mask
      id="seven-spades_svg__h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={5}
      y={0}
      width={246}
      height={350}
    >
      <path
        d="M250.2 13v323.2c0 12.8-9.7 13-9.7 13H9.7s-2.1-.1-4.3-1.4c2.5 1.8 5.1 1.9 5.1 1.9H241s9.7-.3 9.7-13.1V13.1C250.7.3 241 0 241 0h-.5s9.7.3 9.7 13Z"
        fill="url(#seven-spades_svg__g)"
      />
    </mask>
    <g mask="url(#seven-spades_svg__h)">
      <path
        d="M250.2 13v323.2c0 12.8-9.7 13-9.7 13H9.7s-2.1-.1-4.3-1.4c2.5 1.8 5.1 1.9 5.1 1.9H241s9.7-.3 9.7-13.1V13.1C250.7.3 241 0 241 0h-.5s9.7.3 9.7 13Z"
        fill="url(#seven-spades_svg__i)"
      />
    </g>
    <mask
      id="seven-spades_svg__k"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={247}
      height={351}
    >
      <path
        d="M1.3 336.8V13.6C1.3.8 11 .6 11 .6h230.8s2.1.1 4.3 1.4C243.6.2 241 .1 241 .1H10.4S.7.4.7 13.2V337c0 12.8 9.7 13.1 9.7 13.1h.5c.1-.3-9.6-.5-9.6-13.3Z"
        fill="url(#seven-spades_svg__j)"
      />
    </mask>
    <g mask="url(#seven-spades_svg__k)">
      <path
        d="M1.3 336.8V13.6C1.3.8 11 .6 11 .6h230.8s2.1.1 4.3 1.4C243.6.2 241 .1 241 .1H10.4S.7.4.7 13.2V337c0 12.8 9.7 13.1 9.7 13.1h.5c.1-.3-9.6-.5-9.6-13.3Z"
        fill="url(#seven-spades_svg__l)"
      />
      <mask
        id="seven-spades_svg__n"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={25}
        width={2}
        height={302}
      >
        <path
          d="M.8 25.3V327c.2-.6.3-1.2.5-1.8V30.7c-.2-1.8-.3-3.6-.5-5.4Z"
          fill="url(#seven-spades_svg__m)"
        />
      </mask>
      <g mask="url(#seven-spades_svg__n)">
        <path
          d="M.8 25.3V327c.2-.6.3-1.2.5-1.8V30.7c-.2-1.8-.3-3.6-.5-5.4Z"
          fill="url(#seven-spades_svg__o)"
        />
      </g>
    </g>
    <path
      d="M20.5 67.2c-.5 6.5-4.2 11.1-4.2 11.1h8.4c0-.1-3.7-4.6-4.2-11.1Z"
      fill="#000"
    />
    <path
      d="M28.4 57.5c-5.2-3.6-7.8-7.4-7.9-7.5-.1.1-2.6 3.9-7.9 7.5-5.3 3.7-6.5 8.2-4.6 11.6 1.9 3.4 9.4 5.1 12.5-1.7 3 6.8 10.6 5.2 12.5 1.7 1.8-3.4.6-7.9-4.6-11.6ZM30.2 16.1 17.3 45.4h-3.2v-1.1L26 19v-.3h-9.7c-.6 0-1.1.1-1.4.2-.4.1-.7.3-.9.5-.2.2-.4.5-.6.8-.2.3-.4 1-.7 2h-1.9l.4-7.2h19v1.1ZM231.1 282.1c.5-6.5 4.2-11.1 4.2-11.1h-8.4s3.6 4.6 4.2 11.1Z"
      fill="#000"
    />
    <path
      d="M223.2 291.7c5.2 3.6 7.8 7.4 7.9 7.5.1-.1 2.6-3.9 7.9-7.5 5.3-3.7 6.5-8.2 4.6-11.6-1.9-3.4-9.4-5.1-12.5 1.7-3-6.8-10.6-5.2-12.5-1.7-1.9 3.4-.7 7.9 4.6 11.6ZM221.4 333.2l12.9-29.3h3.2v1.1l-11.9 25.2v.3h9.7c.6 0 1.1-.1 1.4-.2.4-.1.7-.3.9-.5.2-.2.4-.5.6-.8.2-.3.4-1 .7-2h1.9l-.4 7.2h-19v-1ZM80.6 181c-1.1 12.9-8.4 21.9-8.4 21.9H89c-.1 0-7.3-9-8.4-21.9Z"
      fill="#000"
    />
    <path
      d="M96.2 161.9c-10.3-7.2-15.5-14.6-15.6-14.8-.1.2-5.2 7.7-15.6 14.8-10.5 7.2-12.9 16.3-9.1 23.1 3.8 6.8 18.8 10.1 24.7-3.4 6 13.5 21 10.2 24.7 3.4 3.7-6.8 1.4-15.9-9.1-23.1ZM80.6 265.5c-1.1-12.9-8.4-21.9-8.4-21.9H89c-.1-.1-7.3 9-8.4 21.9Z"
      fill="#000"
    />
    <path
      d="M96.2 284.6c-10.3 7.2-15.5 14.6-15.6 14.8-.1-.2-5.2-7.7-15.6-14.8-10.5-7.2-12.9-16.3-9.1-23.1 3.8-6.8 18.8-10.1 24.7 3.4 6-13.5 21-10.2 24.7-3.4 3.7 6.8 1.4 15.8-9.1 23.1ZM80.6 84.5c-1.1 12.9-8.4 21.9-8.4 21.9H89c-.1.1-7.3-9-8.4-21.9Z"
      fill="#000"
    />
    <path
      d="M96.2 65.4c-10.3-7.2-15.5-14.6-15.6-14.8-.1.2-5.2 7.7-15.6 14.8-10.5 7.2-12.9 16.3-9.1 23.1 3.8 6.8 18.8 10.1 24.7-3.4 6 13.5 21 10.2 24.7 3.4 3.7-6.8 1.4-15.9-9.1-23.1ZM171 181c-1.1 12.9-8.4 21.9-8.4 21.9h16.8s-7.3-9-8.4-21.9Z"
      fill="#000"
    />
    <path
      d="M186.6 161.9c-10.3-7.2-15.5-14.6-15.6-14.8-.1.2-5.2 7.7-15.6 14.8-10.5 7.2-12.9 16.3-9.1 23.1 3.8 6.8 18.8 10.1 24.7-3.4 6 13.5 21 10.2 24.7 3.4 3.8-6.8 1.4-15.9-9.1-23.1ZM171 265.5c-1.1-12.9-8.4-21.9-8.4-21.9h16.8c0-.1-7.3 9-8.4 21.9Z"
      fill="#000"
    />
    <path
      d="M186.6 284.6c-10.3 7.2-15.5 14.6-15.6 14.8-.1-.2-5.2-7.7-15.6-14.8-10.5-7.2-12.9-16.3-9.1-23.1 3.8-6.8 18.8-10.1 24.7 3.4 6-13.5 21-10.2 24.7-3.4 3.8 6.8 1.4 15.8-9.1 23.1ZM171 84.5c-1.1 12.9-8.4 21.9-8.4 21.9h16.8c0 .1-7.3-9-8.4-21.9Z"
      fill="#000"
    />
    <path
      d="M186.6 65.4c-10.3-7.2-15.5-14.6-15.6-14.8-.1.2-5.2 7.7-15.6 14.8-10.5 7.2-12.9 16.3-9.1 23.1 3.8 6.8 18.8 10.1 24.7-3.4 6 13.5 21 10.2 24.7 3.4 3.8-6.8 1.4-15.9-9.1-23.1ZM125.8 130.8c-1.1 12.9-8.4 21.9-8.4 21.9h16.8s-7.3-9-8.4-21.9Z"
      fill="#000"
    />
    <path
      d="M141.4 111.6c-10.3-7.2-15.5-14.6-15.6-14.8-.1.2-5.2 7.7-15.6 14.8-10.5 7.2-12.9 16.3-9.1 23.1 3.8 6.8 18.8 10.1 24.7-3.4 6 13.5 21 10.2 24.7 3.4 3.8-6.8 1.4-15.8-9.1-23.1Z"
      fill="#000"
    />
    <defs>
      <radialGradient
        id="seven-spades_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(121.871 -119.265) scale(505.879)"
      >
        <stop offset={0.616} />
        <stop offset={0.752} stopColor="#020202" />
        <stop offset={0.804} stopColor="#090909" />
        <stop offset={0.841} stopColor="#151515" />
        <stop offset={0.872} stopColor="#262626" />
        <stop offset={0.899} stopColor="#3C3C3C" />
        <stop offset={0.922} stopColor="#585858" />
        <stop offset={0.944} stopColor="#797979" />
        <stop offset={0.963} stopColor="#9F9F9F" />
        <stop offset={0.982} stopColor="#CBCBCB" />
        <stop offset={0.998} stopColor="#F9F9F9" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="seven-spades_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(121.871 -119.265) scale(505.879)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.788} stopColor="#FDFDFD" />
        <stop offset={0.854} stopColor="#F6F6F6" />
        <stop offset={0.901} stopColor="#EAEAEA" />
        <stop offset={0.94} stopColor="#D9D9D9" />
        <stop offset={0.974} stopColor="#C3C3C3" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="seven-spades_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(126.877 322.836) scale(362.494)"
      >
        <stop offset={0.616} />
        <stop offset={0.71} stopColor="#020202" />
        <stop offset={0.762} stopColor="#0A0A0A" />
        <stop offset={0.805} stopColor="#181818" />
        <stop offset={0.842} stopColor="#2C2C2C" />
        <stop offset={0.875} stopColor="#464646" />
        <stop offset={0.906} stopColor="#656565" />
        <stop offset={0.935} stopColor="#8A8A8A" />
        <stop offset={0.963} stopColor="#B6B6B6" />
        <stop offset={0.988} stopColor="#E5E5E5" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="seven-spades_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(126.877 322.836) scale(362.494)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.747} stopColor="#FDFDFD" />
        <stop offset={0.821} stopColor="#F5F5F5" />
        <stop offset={0.88} stopColor="#E7E7E7" />
        <stop offset={0.932} stopColor="#D3D3D3" />
        <stop offset={0.978} stopColor="#BABABA" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="seven-spades_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-9.895 -.157) scale(402.495)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="seven-spades_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-9.895 -.157) scale(402.495)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="seven-spades_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(69.051 101.814) scale(342.818)"
      >
        <stop />
        <stop offset={0.007} stopColor="#090909" />
        <stop offset={0.048} stopColor="#373737" />
        <stop offset={0.093} stopColor="#626262" />
        <stop offset={0.142} stopColor="#888" />
        <stop offset={0.195} stopColor="#A8A8A8" />
        <stop offset={0.254} stopColor="#C4C4C4" />
        <stop offset={0.32} stopColor="#DADADA" />
        <stop offset={0.397} stopColor="#EBEBEB" />
        <stop offset={0.493} stopColor="#F6F6F6" />
        <stop offset={0.627} stopColor="#FDFDFD" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="seven-spades_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(69.051 101.814) scale(342.818)"
      >
        <stop stopColor="#fff" />
        <stop offset={0.141} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="seven-spades_svg__m"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 130.618 -.08) scale(402.42)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="seven-spades_svg__o"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(180 130.618 -.08) scale(402.42)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgSevenSpades;
